export default __webpack_public_path__ + "static/media/Budget_2023_24_new.21024c91.pdf";